import React from 'react';

const SvgCo = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="CO_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <path id="CO_svg__d" d="M0 9.333h28v5.333H0z" />
      <filter
        x="-5.4%"
        y="-28.1%"
        width="110.7%"
        height="156.2%"
        filterUnits="objectBoundingBox"
        id="CO_svg__c"
      >
        <feMorphology
          radius={0.5}
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        />
        <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          in="shadowOffsetOuter1"
        />
      </filter>
      <path id="CO_svg__f" d="M0 14.667h28V20H0z" />
      <filter
        x="-5.4%"
        y="-28.1%"
        width="110.7%"
        height="156.2%"
        filterUnits="objectBoundingBox"
        id="CO_svg__e"
      >
        <feMorphology
          radius={0.5}
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        />
        <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          in="shadowOffsetOuter1"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="CO_svg__b" fill="#fff">
        <use xlinkHref="#CO_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#CO_svg__a" />
      <g mask="url(#CO_svg__b)">
        <use fill="#000" filter="url(#CO_svg__c)" xlinkHref="#CO_svg__d" />
        <use fill="#0748AE" xlinkHref="#CO_svg__d" />
      </g>
      <g mask="url(#CO_svg__b)">
        <use fill="#000" filter="url(#CO_svg__e)" xlinkHref="#CO_svg__f" />
        <use fill="#DE2035" xlinkHref="#CO_svg__f" />
      </g>
      <path fill="#FFD935" mask="url(#CO_svg__b)" d="M0 0h28v9.333H0z" />
    </g>
  </svg>
);

export default SvgCo;
